import React from 'react';
import PropTypes from 'prop-types';
import { MAX_LAYOUT_COLUMNS } from 'constants/layoutConstants';
import { StyledColumn } from '../styled';

const calculateWidthPercent = (configWidth) => {
  const columns = Math.round(configWidth * MAX_LAYOUT_COLUMNS);
  const colWidth = Math.round((columns / MAX_LAYOUT_COLUMNS) * 100);
  return `${colWidth}%`;
};

export const Column = React.memo((props) => {
  const {
    children, className, width
  } = props;
  return (
    <StyledColumn
      style={{ width: calculateWidthPercent(width) }}
      className={className}
    >
      {children}
    </StyledColumn>
  );
});

Column.propTypes = {
  children: PropTypes.node.isRequired,
  className: PropTypes.string,
  width: PropTypes.number,
};

Column.defaultProps = {
  className: undefined,
  width: 1
};

export default Column;
